import template from './main.html';
import controller from './main.controller';
import './main.scss';

const mainComponent = {
  bindings: {},
  template,
  controller,
};

export default mainComponent;



// WEBPACK FOOTER //
// ./client/app/components/main/main.component.js